import {Injectable} from '@angular/core';
import {AngularFireDatabase} from 'angularfire2/database';
import {Subscription} from 'rxjs/Subscription';
import {Schedule} from '../models/Schedule';
import {Reason} from '../models/Reason';
import {Configuration} from '../models/Configuration';
import {AllowedDevice} from '../models/AllowedDevice';

@Injectable()
export class TimeTrackerService {

    public static COMPANIES = 'companies';
    public static COMPANY_DATA = 'company-data';
    public static USERS = 'users';
    public static USER_CHECKS = 'user-checks';
    public static ALLOWED_DEVICES = 'allowed-devices';
    public static TEAMS = 'groups';
    public static USER_DEVICES = 'user-devices';
    public static ADMINS = 'admins';
    public static REASONS = 'reasons';
    public static SCHEDULES = 'schedules';
    public static CONFIG = 'config';
    public static WIFI = 'wifiList';

    constructor(public af: AngularFireDatabase) {
        // (new FirebaseApp()).
        // af.list('users')
        //     .snapshotChanges().subscribe(ref => {
        //     console.log('************************************');
        //     console.log(ref);
        // });
    }

    public getChecks(userId: string, companyId: string, fromDateMillis, toDateMillis, fcnResult) {
        let sub: Subscription = this.af
            .list(TimeTrackerService.COMPANY_DATA + '/' + companyId + '/' + TimeTrackerService.USER_CHECKS + '/' + userId,
                query => query.orderByChild('date').startAt(fromDateMillis).endAt(toDateMillis))
            .valueChanges().subscribe((ref) => {
                sub.unsubscribe();
                fcnResult(ref);
            });
    }

    public getAllowedDevices(companyId: string, fcnResult) {
        this.af.list<AllowedDevice>(TimeTrackerService.COMPANY_DATA + '/' + companyId + '/' + TimeTrackerService.ALLOWED_DEVICES,
            query => query.orderByChild('date')
        ).valueChanges()
            .subscribe(ref => fcnResult(ref));
    }

    public createAllowedDevice(companyId: string, device: AllowedDevice, fcnResult) {
        device.id = TimeTrackerService.guid();
        this.af.object(TimeTrackerService.COMPANY_DATA + '/' + companyId + '/' + TimeTrackerService.ALLOWED_DEVICES + '/' + device.id)
            .set(device)
            .then(ref => fcnResult(ref));
    }

    public getAvailableCompanies(fcnResult) {
        this.af.list(TimeTrackerService.COMPANIES, ref => ref.orderByChild('active').equalTo(true)).valueChanges()
            .subscribe(ref => fcnResult(ref));
    }

    public getAvailableGroupsFromCompany(companyId, fcnResult) {
        this.af.list(TimeTrackerService.COMPANY_DATA + '/' + companyId + '/' + TimeTrackerService.TEAMS).valueChanges()
            .subscribe(ref => fcnResult(ref));
    }

    public getUsersFromCompany(companyId, fcnResult) {
        let users = [];
        let numberUsers = 0;
        let currentRequest = 0;

        console.log('getUsersFromCompany()');
        this.af.list(TimeTrackerService.COMPANY_DATA + '/' + companyId + '/' + TimeTrackerService.USERS).snapshotChanges()
            .subscribe(ref => {
                console.log(ref.length);
                numberUsers = ref.length;
                currentRequest = 0;
                ref.forEach(value => {
                    this.loadCompleteProfileFromUID(value.key, function (user) {
                        console.log('loadCompleteProfileFromUID()');
                        users.push(user);
                        currentRequest++;
                        if (currentRequest >= numberUsers) {
                            fcnResult(users);
                        }
                    });
                });
            });
    }

    public getUsersFromTeam(companyId, teamId, fcnResult) {
        this.af.list(TimeTrackerService.COMPANY_DATA + '/' + companyId + '/' + TimeTrackerService.TEAMS + '/' + teamId + '/' + TimeTrackerService.USERS).valueChanges()
            .subscribe(ref => fcnResult(ref));
    }

    public getTeamsFromCompany(companyId, fcnResult) {
        this.af.list(TimeTrackerService.COMPANY_DATA + '/' + companyId + '/' + TimeTrackerService.TEAMS).valueChanges()
            .subscribe(ref => fcnResult(ref));
    }

    public getUserFromId(userId, fcnResult) {
        this.af.object(TimeTrackerService.USERS + '/' + userId).snapshotChanges()
            .subscribe(ref => fcnResult(ref));
    }

    public getTeamFromCompany(companyId, teamId, fcnResult) {
        this.af.object(TimeTrackerService.COMPANY_DATA + '/' + companyId + '/' + TimeTrackerService.TEAMS + '/' + teamId).valueChanges()
            .subscribe(ref => fcnResult(ref));
    }

    public getCompanyFromId(companyId, fcnResult) {
        this.af.object(TimeTrackerService.COMPANIES + '/' + companyId).valueChanges()
            .subscribe(ref => fcnResult(ref));
    }

    // this function load all subCompanyGroups
    public getChildGroups(rootCompanyId, fcnResult) {
        this.af.list(TimeTrackerService.COMPANIES, query => query.orderByChild('parentId').equalTo(rootCompanyId))
            .valueChanges()
            .subscribe(ref => fcnResult(ref));
    }

    public getReasonsFromCompanyId(companyId, fcnResult) {
        this.af.list<Reason>(TimeTrackerService.COMPANY_DATA + '/' + companyId + '/' + TimeTrackerService.REASONS,
            query => query.orderByChild('date')
        ).valueChanges()
            .subscribe(ref => fcnResult(ref));
    }

    public getConfigurationFromCompanyId(companyId, fcnResult) {
        this.af.object<Configuration>(TimeTrackerService.COMPANY_DATA + '/' + companyId + '/' + TimeTrackerService.CONFIG)
            .snapshotChanges()
            .subscribe(ref => fcnResult(ref.payload.val()));
    }

    public getDevicesFromUserId(userId, fcnResult) {
        this.af.list(TimeTrackerService.USER_DEVICES, ref => ref.orderByChild('userId').equalTo(userId))
            .valueChanges()
            .subscribe(ref => {
                fcnResult(ref[0]);
            });
    }

    public registerUserDevice(userId, device, gcnResult) {
        this.af.list(TimeTrackerService.USER_DEVICES)
            .push(device)
            .then(ref => gcnResult(ref));
    }

    public createSchedule(schedule: Schedule, fcnResult) {
        schedule.id = TimeTrackerService.guid();
        this.af.object(TimeTrackerService.SCHEDULES + '/' + schedule.id)
            .set(schedule)
            .then(ref => fcnResult(ref));
    }

    public loadCompleteProfileFromUID(userId, fcnResult) {
        const MAX_REQUEST_PROFILE = 3;
        let currentRequestProfile = 0;
        let errorMessage = '';
        let user;
        this.getUserFromId(userId, userRes => {
            console.log('getUserFromId()');
            user = userRes;
            if (user != null && user.id) {
                // Load Company
                this.getCompanyFromId(user.companyId, refComp => {
                    user.company = refComp;
                    console.log('-->getCompanyFromId()');
                    finisLoadRequest();
                });
                // Load Team
                this.getTeamFromCompany(user.companyId, user.teamId, refTeam => {
                    user.team = refTeam;
                    console.log('-->getTeamFromCompany()');
                    finisLoadRequest();
                });
                // Load Device
                this.getDevicesFromUserId(user.id, refDevice => {
                    user.device = refDevice;
                    console.log('-->getDevicesFromUserId()');
                    finisLoadRequest();
                });
            } else {
                fcnResult({});
            }
        });

        function finisLoadRequest() {
            currentRequestProfile++;
            if (currentRequestProfile == MAX_REQUEST_PROFILE) {
                fcnResult(user);
            }
        }
    }

    public static guid() {
        function _p8(s) {
            let p = (Math.random().toString(16) + '000000000').substr(2, 8);
            return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
        }

        return _p8(false) + _p8(true) + _p8(true) + _p8(false);
    }
}



// WEBPACK FOOTER //
// ./src/app/time-tracker-service.service.ts